"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAnswerFieldTypeFromQuestionType = void 0;
const AnswerFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/AnswerFieldType"));
const FormQuestionType_1 = __importDefault(require("../FormQuestionType"));
function getAnswerFieldTypeFromQuestionType(qt) {
    switch (qt) {
        case FormQuestionType_1.default.CHECK:
            return AnswerFieldType_1.default.ANSWER_CHECK;
        case FormQuestionType_1.default.DATETIME:
            return AnswerFieldType_1.default.ANSWER_DATETIME;
        case FormQuestionType_1.default.NUMBER:
            return AnswerFieldType_1.default.ANSWER_NUMBER;
        case FormQuestionType_1.default.RATING:
            return AnswerFieldType_1.default.ANSWER_RATING;
        case FormQuestionType_1.default.LIST:
            return AnswerFieldType_1.default.ANSWER_LIST;
        case FormQuestionType_1.default.PHOTO:
            return AnswerFieldType_1.default.ANSWER_PHOTO;
        case FormQuestionType_1.default.SIGNATURE:
            return AnswerFieldType_1.default.ANSWER_SIGNATURE;
        case FormQuestionType_1.default.TEXT:
            return AnswerFieldType_1.default.ANSWER_TEXT;
        case FormQuestionType_1.default.SPT:
            return AnswerFieldType_1.default.ANSWER_SPT;
        case FormQuestionType_1.default.ASSET:
            return AnswerFieldType_1.default.ANSWER_SPT;
        default:
            return undefined;
    }
}
exports.getAnswerFieldTypeFromQuestionType = getAnswerFieldTypeFromQuestionType;
exports.default = getAnswerFieldTypeFromQuestionType;
